import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { platformMessageStore, useTranslation, userSettingsStore } from '@pascal/pascal-core';

import { TranslationKeys } from '../../enums/translationKeys';

const TurboModeSection = observer(() => {
  const t = useTranslation();
  const { isAnimationOn, setIsAnimationOn } = userSettingsStore;
  const { isRepliedGame } = platformMessageStore;

  useEffect(() => {
    if (isRepliedGame && !isAnimationOn) {
      setIsAnimationOn();
    }
  }, [isRepliedGame, isAnimationOn, setIsAnimationOn]);

  return (
    <div
      onClick={setIsAnimationOn}
      className={`action-btn-el turbo-btn-block ${!isAnimationOn ? 'active' : ''}`}
    >
      <button type='button' className={`action-btn icon-energy${!isAnimationOn ? '-filled' : ''}`}>
        {/* <i className="lightning icon-energy"></i> */}
      </button>
      <div className='action-btn-el-value'>
        <p className='action-dropdown-selected'>{t(TranslationKeys.Turbo)}</p>
      </div>
    </div>
  );
});

export default TurboModeSection;
